/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.terms_checkbox = this.querySelector('input[type="checkbox"]');
      if (this.terms_checkbox) {
        this.terms_checkbox.setCustomValidity(this.dataset.message || theme.strings.requiresTerms);
      }
    }
  }
  customElements.define('terms-checkbox', TermsCheckbox);
}


if (!window.termsCheckboxCheckoutGuardBound) {
  window.termsCheckboxCheckoutGuardBound = true;
  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest(
      '.button.checkout-button, .checkout-button, [data-target="coverage-button"], [data-target="non-coverage-button"], [data-target="checkout-buttons-container"] button'
    );
    if (!checkoutButton) {
      return;
    }

    const scope = checkoutButton.closest('#Cart-Drawer, #Cart') || document;
    const checkboxes = scope.querySelectorAll('terms-checkbox input[type="checkbox"]');
    let allValid = true;

    checkboxes.forEach((checkbox) => {
      if (!checkbox.checked) {
        allValid = false;
        checkbox.reportValidity();
        checkbox.focus();
      }
    });

    if (!allValid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
    }
  }, true);
}